import axios from "axios";

const { VUE_APP_APPTS_API, VUE_APP_KB_API } = process.env;
let apiClientService = axios.create({
  baseURL: `${process.env.VUE_APP_APPTS_API}`,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});
const randomNo = Math.random();

const sendSMS = async _data => {
  let result = axios
    .post(`${VUE_APP_KB_API}/kb-api/sms`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const getAllAppts = async () => {
  const response = await axios.get(
    `${VUE_APP_APPTS_API}/availability?rnd=${randomNo}`
  );
  return response.data;
};

const getSlotsById = async _id => {
  const response = await axios.get(
    `${VUE_APP_APPTS_API}/v1/booking/availability/${_id}?rnd=${randomNo}`
  );
  return response.data;
};
const fetchSlotTerms = async _id => {
  const response = await axios.get(
    `${VUE_APP_APPTS_API}/slot/terms/${_id}?rnd=${randomNo}`
  );
  return response.data;
};

const getBookedAppts = async () => {
  const response = await axios.get(
    `${VUE_APP_APPTS_API}/booked?rnd=${randomNo}`
  );
  return response.data;
};

const getWeeksAppts = async _data => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/availability`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const getAppt = async _id => {
  const response = await axios.get(
    `${VUE_APP_APPTS_API}/slot/${_id}?rnd=${randomNo}`
  );
  return response.data;
};

const getUsers = async () => {
  const response = await axios.get(
    `${VUE_APP_APPTS_API}/users?rnd=${randomNo}`
  );
  return response.data;
};

const saveAppt = async _data => {
  let result = await apiClientService
    .put(`${VUE_APP_APPTS_API}/slot/${_data.data._id}`, _data)
    .catch(function(error) {
      let errorObj = {};
      errorObj.error = error;
      errorObj.Error = true;
      if (
        error.response &&
        error.response.request &&
        error.response.request.response
      ) {
        let response = JSON.parse(error.response.request.response);
        if (response.message) {
          error.Message = response.message;
          errorObj.Message = response.message;
        }
      }

      return errorObj;
    });
  return result;
};

const cancelAppt = async _id => {
  let result = await apiClientService
    .delete(`${VUE_APP_APPTS_API}/slot/${_id}`)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const sendBulkData = async _data => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/bulk-create`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const updateFacility = async (_id, _data) => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/facility/${_id}`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const fetchFacility = async _id => {
  let result = await apiClientService
    .get(`${VUE_APP_APPTS_API}/facility/${_id}?rnd=${randomNo}`)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const fetchFacilities = async () => {
  let result = await apiClientService
    .get(`${VUE_APP_APPTS_API}/facilities?rnd=${randomNo}`)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const createFacilitySlots = async _data => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/facility-bulk-create`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const createFacilityPricing = async _data => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/facility-bulk-create-pricing`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const makePayment = async () => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/create-checkout-session`, {})
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const getFacilityPrice = async (_id, _data) => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/check-pricing/${_id}`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const createProduct = async _data => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/create-product`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const createPaymentLink = async _data => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/payment-link`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const sendPaymentLink = async (_id, _data) => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/email-payment-link/${_id}`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const getPaymentStatus = async _id => {
  let result = await apiClientService
    .get(`${VUE_APP_APPTS_API}/pay-status/${_id}?rnd=${randomNo}`)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const updateAppt = async _data => {
  let result = await apiClientService
    .put(`${VUE_APP_APPTS_API}/update/slot/${_data.data._id}`, _data)
    .catch(function(error) {
      let errorObj = {};
      errorObj.error = error;
      errorObj.Error = true;
      if (
        error.response &&
        error.response.request &&
        error.response.request.response
      ) {
        let response = JSON.parse(error.response.request.response);
        if (response.message) {
          error.Message = response.message;
          errorObj.Message = response.message;
        }
      }

      return errorObj;
    });
  return result;
};

const sendBookingConfirmation = async (_id, _data) => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/email-conf/${_id}`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const blockAvailablity = async (_type, _data) => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/block-availability/${_type}`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const checkAvailability = async _data => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/v1/make-booking/check`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};
const getSlotsByStatus = async (_status, _data) => {
  const response = await axios
    .post(`${VUE_APP_APPTS_API}/status/${_status}`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return response.data;
};

const getSportsOptions = async () => {
  let result = await apiClientService
    .get(`${VUE_APP_APPTS_API}/facilitySports?rnd=${randomNo}`)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};
const fetchPageContent = async () => {
  let result = await apiClientService
    .get(`${VUE_APP_APPTS_API}/page-content?rnd=${randomNo}`)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const updateSportsOptions = async _data => {
  let result = await apiClientService
    .post(`${VUE_APP_APPTS_API}/facilitySports`, _data)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

const deleteSportsOptions = async _id => {
  let result = axios
    .delete(`${VUE_APP_APPTS_API}/facilitySports/${_id}`)
    .catch(function(error) {
      error.Error = true;
      return error;
    });
  return result;
};

export {
  sendSMS,
  getAllAppts,
  getAppt,
  sendBulkData,
  getWeeksAppts,
  cancelAppt,
  saveAppt,
  getBookedAppts,
  getUsers,
  updateFacility,
  fetchFacility,
  fetchFacilities,
  createFacilitySlots,
  createFacilityPricing,
  getSlotsById,
  makePayment,
  getFacilityPrice,
  createProduct,
  createPaymentLink,
  getPaymentStatus,
  updateAppt,
  sendPaymentLink,
  sendBookingConfirmation,
  blockAvailablity,
  checkAvailability,
  getSlotsByStatus,
  getSportsOptions,
  updateSportsOptions,
  deleteSportsOptions,
  fetchPageContent,
  fetchSlotTerms
};
